import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Source from "./Source";
import Connection from "./Connection";
import DataType from "./DataType";
import Indicator from "./Indicator";
import { sourcelist } from "./lists/sourceList";
import { connectionlist } from "./lists/connectionList";
import { indicatorlist } from "./lists/indicatorList";
import { datatypelist } from "./lists/dataTypeList";
import {
  sourceGroups,
  connectionGroups,
  indicatorGroups,
  datatypeGroups
} from "./lists/groupLists";
import { descriptions } from "./lists/sourceDescriptions";

const useStyles = makeStyles(theme => ({
  svgContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    overflow: "scroll"
  }
}));

const SourceGraphic = props => {
  const classes = useStyles();

  const [currentGroup, setCurrentGroup] = useState(undefined);

  const setItemGroups = (itemList, groupsList) => {
    let arr = [];
    itemList.forEach(item => {
      if (!item.groups) {
        groupsList.forEach(groupItem => {
          if (groupItem.id === item.id) {
            console.log(`${groupItem.id}, ${item.id}`);
            item.groups = groupItem.groups;
          }
        });
        if (item.id.includes("source")) {
          descriptions.forEach(d => {
            if (d.id === item.id) {
              item.description = d;
            }
          });
        }
        item.groups.push(item.id);
      }
      arr.push(item);
    });
    return arr;
  };

  const sources = setItemGroups(sourcelist, sourceGroups).map(obj => (
    <Source
      key={obj.id}
      {...obj}
      updateCurrent={() => {
        setCurrentGroup(obj.id);
      }}
      removeCurrent={() => setCurrentGroup(undefined)}
      current={currentGroup}
    />
  ));

  const connections = setItemGroups(connectionlist, connectionGroups).map(
    obj => <Connection key={obj.id} {...obj} current={currentGroup} />
  );

  const datatypes = setItemGroups(datatypelist, datatypeGroups).map(obj => (
    <DataType
      key={obj.id}
      {...obj}
      updateCurrent={() => {
        setCurrentGroup(obj.id);
      }}
      removeCurrent={() => setCurrentGroup(undefined)}
      current={currentGroup}
    />
  ));

  const indicators = setItemGroups(indicatorlist, indicatorGroups).map(obj => (
    <Indicator
      key={obj.id}
      {...obj}
      updateCurrent={() => {
        setCurrentGroup(obj.id);
      }}
      removeCurrent={() => setCurrentGroup(undefined)}
      current={currentGroup}
    />
  ));

  return (
    <div className={classes.svgContainer}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1080 720"
        xmlns="http://www.w3.org/2000/svg"
      >
        {connections}
        {sources}
        {datatypes}
        {indicators}
      </svg>
    </div>
  );
};

export default SourceGraphic;
